import { ReactNode } from "react"

const Container = ({
  children
}: {
  children: ReactNode
}) => <div className="p-4 my-4 mx-auto max-w-screen-sm">{children}</div>

export default Container